// import React, { useState, useEffect } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import "./addRule.css";
// import logoBlue from "../../components/images/logoblue.png";
// import { Delete, Edit, Check, Sync, ArrowBack } from "@material-ui/icons";
// import { createRule } from "../../services/game.services.js";

// const initialState = {
//   ruleName: "",
//   ruleId: "",
//   gender: "",
//   gamePeriods: 0,
//   periodDuration: 0,
//   gapBetweenPeriods: 0,
//   gapBetweenHalves: 0,
//   timeoutsPerHalf: 0,
//   timeoutsInOvertimePeriod: 0,
//   maxOvertimePeriods: 0,
//   overtimePeriodDuration: 0,
//   goalDiffForRunningClock: 0,
//   maxPersonalFouls: 0,
//   maxFOViolationPerHalf: 0,
//   mercyRuleLimit: "",
// };

// export default function AddRule(props) {
//   const [visible, setVisible] = useState(false);

//   const [initialStateForm, setInitialStateForm] = useState(initialState);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleFormChange = (name, value) => {
//     setInitialStateForm((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleCreate = async (e) => {
//     e.preventDefault();
//     console.log("created rule data", initialStateForm);

//     try {
//       setLoading(true);
//       const response = await createRule(
//         initialStateForm,
//         JSON.parse(sessionStorage.getItem("myData"))
//       );
//       // console.log('request workingggggg', response.data);
//       // toggleSuccessModal();
//     } catch (e) {
//       setError(e);
//     } finally {
//       setLoading(false);
//     }
//   };
//   let history = useHistory();

//   return (
//     <div className="addRule">
//       <div className="addRuleHeader">
//         <div className="titleWithBack">
//           <button className="backBtn" onClick={() => history.goBack()}>
//             <ArrowBack className="backBtnIcon" />
//           </button>
//           <h1 className="addRuleTitle">Add New Rule</h1>
//         </div>
//         <img
//           className="addRuleLogo"
//           src={logoBlue}
//           alt="logo"
//           width="150px"
//         ></img>
//       </div>

//       <form className="addRuleForm">
//         <div className="ruleNameCodeBox">
//           <div className="addRuleItem">
//             <input
//               type="text"
//               placeholder="Enter Group/ Rule Name"
//               value={initialStateForm.ruleName}
//               onChange={(e) => handleFormChange("ruleName", e.target.value)}
//             />
//           </div>
//           <div className="addRuleItem">
//             <input
//               type="text"
//               placeholder="B/G or M/F + rule code"
//               value={initialStateForm.ruleId}
//               onChange={(e) => handleFormChange("ruleId", e.target.value)}
//             />
//           </div>
//         </div>
//         <div className="addRuleDesc">
//           <input
//             id="r1"
//             type="radio"
//             value="male"
//             name="gender"
//             onChange={(e) => handleFormChange("gender", e.target.value)}
//           />
//           <label for="r1">Male</label>
//           <input
//             id="r2"
//             type="radio"
//             value="female"
//             name="gender"
//             onChange={(e) => handleFormChange("gender", e.target.value)}
//           />
//           <label for="r2">Female</label>
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Periods per Game :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("gamePeriods", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Minutes per Period :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("periodDuration", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Minutes Between Periods :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("gapBetweenPeriods", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Minutes Between Halves :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("gapBetweenHalves", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Timeout per Half :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("timeoutsPerHalf", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Timeouts in Overtime :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange(
//                 "timeoutsInOvertimePeriod",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">No. of Overtime Periods :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("maxOvertimePeriods", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Minutes Per Overtime Periods :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange(
//                 "overtimePeriodDuration",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Goal Differential for running clock :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange(
//                 "goalDiffForRunningClock",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Max # Of Personal Fouls :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("maxPersonalFouls", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Max # Of FO Violations Per Half :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange(
//                 "maxFOViolationPerHalf",
//                 parseInt(e.target.value)
//               )
//             }
//           />
//         </div>

//         <button className="addRuleButton" onClick={handleCreate}>
//           Create
//         </button>
//       </form>
//     </div>
//   );
// }



// src/components/AddRule/AddRule.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ArrowBack } from '@material-ui/icons';
import { addRule } from '../../redux/reducers/ruleReducer';
import logoBlue from '../../components/images/logoblue.png';
import './addRule.css';

const initialState = {
  ruleName: '',
  ruleId: '',
  gender: '',
  gamePeriods: 0,
  periodDuration: 0,
  gapBetweenPeriods: 0,
  gapBetweenHalves: 0,
  timeoutsPerHalf: 0,
  timeoutsInOvertimePeriod: 0,
  maxOvertimePeriods: 0,
  overtimePeriodDuration: 0,
  goalDiffForRunningClock: 0,
  maxPersonalFouls: 0,
  maxFOViolationPerHalf: 0,
  mercyRuleLimit: '',
};

export default function AddRule() {
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading, error } = useSelector((state) => state.rule);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCreate = (e) => {
    e.preventDefault();
    dispatch(addRule(initialStateForm));
  };

  return (
    <div className="addRule">
      <div className="addRuleHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="addRuleTitle">Add New Rule</h1>
        </div>
        <img className="addRuleLogo" src={logoBlue} alt="logo" width="150px"></img>
      </div>

      <form className="addRuleForm">
        <div className="ruleNameCodeBox">
          <div className="addRuleItem">
            <input
              type="text"
              placeholder="Enter Group/ Rule Name"
              value={initialStateForm.ruleName}
              onChange={(e) => handleFormChange('ruleName', e.target.value)}
            />
          </div>
          <div className="addRuleItem">
            <input
              type="text"
              placeholder="B/G or M/F + rule code"
              value={initialStateForm.ruleId}
              onChange={(e) => handleFormChange('ruleId', e.target.value)}
            />
          </div>
        </div>
        <div className="addRuleDesc">
          <input
            id="r1"
            type="radio"
            value="male"
            name="gender"
            onChange={(e) => handleFormChange('gender', e.target.value)}
          />
          <label htmlFor="r1">Male</label>
          <input
            id="r2"
            type="radio"
            value="female"
            name="gender"
            onChange={(e) => handleFormChange('gender', e.target.value)}
          />
          <label htmlFor="r2">Female</label>
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Periods per Game :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('gamePeriods', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Minutes per Period :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('periodDuration', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Minutes Between Periods :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('gapBetweenPeriods', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Minutes Between Halves :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('gapBetweenHalves', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Timeout per Half :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('timeoutsPerHalf', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Timeouts in Overtime :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('timeoutsInOvertimePeriod', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">No. of Overtime Periods :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('maxOvertimePeriods', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Minutes Per Overtime Periods :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('overtimePeriodDuration', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Goal Differential for running clock :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('goalDiffForRunningClock', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Max # Of Personal Fouls :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('maxPersonalFouls', parseInt(e.target.value))}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Max # Of FO Violations Per Half :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange('maxFOViolationPerHalf', parseInt(e.target.value))}
          />
        </div>

        <button className="addRuleButton" onClick={handleCreate} disabled={loading}>
          {loading ? 'Creating...' : 'Create'}
        </button>
        {error && <div className="error">Error: {error}</div>}
      </form>
    </div>
  );
}
